/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = AVAILABLE
 *
 * 1 = RESERVED
 *
 * 2 = SOLD
 *
 * 3 = UNAVAILABLE
 */
export enum InventoryVehicleStatus {
  AVAILABLE = 0,
  RESERVED = 1,
  SOLD = 2,
  UNAVAILABLE = 3,
}
